import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/salesCopy';
import { checkoutUrl } from '../data/offer';
import { handleCheckoutClick } from './CtaButton';
export function BonusStack() {
  return <section className="w-full bg-night" data-id="element-10" data-mp="2lsxc71dulbo">
      <div className="mx-auto max-w-6xl px-4 py-10 sm:px-5 sm:py-16 lg:py-20" data-id="element-11" data-mp="2in90u0kvnh0">
        <div className="text-center" data-id="element-12" data-mp="6la20y8zjefs">
          <p className="text-[10px] font-semibold uppercase tracking-[0.24em] text-gold sm:text-xs sm:tracking-[0.28em]" data-id="element-13" data-mp="361gj2wu5du6f">
            Included today at no extra cost
          </p>
          <h2 className="mt-4 font-display text-[1.75rem] uppercase leading-[1] tracking-tight text-cream sm:text-5xl" data-id="element-14" data-mp="3axx3ph251qer">
            6 <span className="text-gold" data-id="element-15" data-mp="3jt4sutgxc6k8">free bonuses</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-[15px] leading-relaxed text-cream-muted sm:text-base" data-id="element-16" data-mp="3jufykytxjodz">
            Six PDF guides with the material you actually hand a student: tabs, melodies, drills,
            lesson sheets, a 30-day practice calendar and ten pieces of sheet music.
          </p>
        </div>

        <ul className="mt-9 grid grid-cols-1 gap-4 sm:mt-12 sm:grid-cols-2 sm:gap-5 lg:grid-cols-3" data-id="element-17" data-mp="3nbyx500orhjr">
          {bonuses.map(bonus => <li key={bonus.number} className="flex h-full flex-row overflow-hidden rounded-2xl border border-line bg-panel sm:flex-col" data-id="element-18" data-mp="3ijp8rof7ypjl">
              <div className="w-28 shrink-0 bg-night-deep sm:w-full" data-id="element-19" data-mp="38n2p32ymq4j5">
                <img src={bonus.cover} alt={`Cover of ${bonus.title}`} className="h-full w-full object-cover sm:aspect-square" data-id="element-20" data-mp="34l8t37zdpopb" />
              </div>
              <div className="flex flex-1 flex-col p-4 sm:p-6" data-id="element-21" data-mp="2unku25uqpv1c">
                <div className="flex flex-wrap items-center gap-x-2 gap-y-1" data-id="element-22" data-mp="2upe47v4kaxe3">
                  <span className="text-[10px] font-semibold uppercase tracking-[0.14em] text-cream-muted sm:text-xs" data-id="element-23" data-mp="xtzvhfu5zbt0">
                    Bonus {bonus.number}
                  </span>
                  <span className="rounded-full bg-gold px-2 py-0.5 text-[10px] font-semibold uppercase tracking-[0.06em] text-night sm:px-2.5 sm:text-xs" data-id="element-24" data-mp="2nb4y8clgaufv">
                    <span className="line-through" data-id="element-25" data-mp="2ddz5kzx6uvdj">{bonus.value}</span> · Free
                  </span>
                </div>
                <h3 className="mt-2 font-display text-base uppercase leading-tight tracking-tight text-cream sm:text-lg" data-id="element-26" data-mp="2idv9kz5vymt3">
                  {bonus.title}
                </h3>
                <p className="mt-2 text-[13px] leading-relaxed text-cream-muted sm:mt-3 sm:text-[15px]" data-id="element-27" data-mp="3b17jo9uv125i">
                  {bonus.body}
                </p>
              </div>
            </li>)}

          <li className="flex h-full flex-col justify-center rounded-2xl border border-gold/40 bg-panel-soft p-6 sm:p-8" data-id="element-28" data-mp="312s494573hbu">
            <GiftIcon className="h-7 w-7 text-gold sm:h-8 sm:w-8" aria-hidden="true" data-id="element-29" data-mp="1ko09ikkktxzd" />
            <p className="mt-4 font-display text-xl uppercase leading-tight text-cream sm:mt-5 sm:text-2xl" data-id="element-30" data-mp="1poekaadkbm13">
              All 6 bonuses, <span className="text-gold" data-id="element-31" data-mp="7p8akdxh0kzx">yours free</span>
            </p>
            <p className="mt-3 text-[15px] leading-relaxed text-cream-muted" data-id="element-32" data-mp="2s7z1nhuqq1f">
              Every bonus is included with the bundle today — all in PDF, sent to your email. No
              upsells, no extra fees.
            </p>
            <a href={checkoutUrl} rel="noopener" onClick={() => handleCheckoutClick('bonus_section')} className="mt-6 inline-flex w-full items-center justify-center rounded-full bg-gold px-6 py-3.5 text-xs font-semibold uppercase tracking-[0.06em] text-night transition-[transform,background-color] duration-150 ease-expo hover:-translate-y-0.5 hover:bg-gold-soft active:translate-y-0" data-id="element-33" data-mp="cq4889r8baww">
              Claim the bundle for $27
            </a>
          </li>
        </ul>
      </div>
    </section>;
}